<template>
	<div>

		<el-form :model="ruleForm.grantList[index]" :rules="rules" ref="ruleForm" label-width="100px"
			class="demo-ruleForm"  label-position="top">

			<span>银行</span>
			<div style="margin-top: 20px;">
				<el-select v-model="ruleForm.bank_id" style="width:80%;" placeholder="请选择银行" clearable>
					<el-option v-for="item in causeList" :key="item.id" :label="item.bank_name " :value="item.id">
					</el-option>
				</el-select>
			</div>

			<el-row style="margin:30px 0 20px 0;">
				<el-col :span="14">
					<span>拆分账户</span>
				</el-col>
				<el-col :span="6">
					<span>拆分比例</span>
				</el-col>
			</el-row>

			<el-row v-for="(item, index) in rangeListIndex" :key="index">
				<el-col :span="14">
					<el-form-item prop="split_id">
						<el-select v-model="ruleForm.grantList[index].split_id" style="width:80%;margin-left: 20%;"
							placeholder="请选择拆分账户" clearable>
							<el-option v-for="item in cfzhList" :key="item.id" :label="item.data" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item prop="grant_proportion" style="margin-left: 10px;">
						<el-input v-model="ruleForm.grantList[index].grant_proportion"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="3">
					<img src="../../../assets/icon/添加.png" style="height: 25px; margin-left: 3%; margin-top: 5px;"
						v-show="index == (rangeListIndex - 1)" @click="AddRecord" />
					<img src="../../../assets/icon/减少.png" style="height: 25px; margin-left: 10px; margin-top: 5px;"
						v-show="index != 0" @click="RemoveRecord(index)" />
				</el-col>
			</el-row>

			<el-form-item label-width="0" style="text-align: center; ">
				<el-button type="primary" @click="submitForm()"
					style="background-color: #006E4B; border-color: #006E4B; width: 140px;">保存</el-button>
					
			</el-form-item>
		</el-form>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 银行
				causeList: [],
				cfzhList: [],
				rangeListIndex: 1,
				ruleForm: {
					id: '',
					bank_id: '',
					grantList: [{
						split_id: '',
						grant_proportion: '',
						flag: 0
					}]
				},

				//表单验证
				// rules: {
					// 	bank_id: [{
					// 		required: true,
					// 		message: '请选择银行！',
					// 		trigger: 'blur'
					// 	}],
					// 	split_id: [{
					// 		required: true,
					// 		message: '请选择拆分账户！',
					// 		trigger: 'blur'
					// 	}],
					// 	grant_proportion: [{
					// 		required: true,
					// 		message: '请输入拆分比例！',
					// 		trigger: 'blur'
					// 	}],
			}
		},
		methods: {
			//添加
			AddRecord() {
				this.rangeListIndex += 1;
				this.$set(this.ruleForm.grantList, this.ruleForm.grantList.length, {
					split_id: "",
					grant_proportion: "",
					flag: this.ruleForm.grantList.length,
				});
			},
			
				// 减少
			RemoveRecord(e) {
				this.rangeListIndex -= 1;
				this.ruleForm.grantList.splice(e, 1);
			},
			async submitForm(){
			    var url = 'GrantProportion/insertGrant';
			    var record = {
			        bank_id: this.ruleForm.bank_id,
			        grantList: this.ruleForm.grantList,
			    };
			    var data = await this.$globals.AxiosPost(url, record);
			    if (data === '-2000') {
			        this.$message.error('服务器未响应！请稍后重试');
			    } else {
			        var code = data.code;
			        var data = data.data;
			        if (code === '200') {
			            this.$message.success(data);
			            this.Return();
						this.qingkong()
			        } else {
			            this.$message.warning(data);
			        }
			    }
			},
			Return() {
			    this.$parent.$parent.Return();
			},
			qingkong(){
				this.ruleForm.id = '';
				this.ruleForm.bank_id = '';
				this.ruleForm.split_id = '';
				this.ruleForm.grant_proportion = '';
				this.ruleForm.grantList = [];
				this.ruleForm.grantList = [{
					flag: 0,
					split_id:'',
					grant_proportion:'',
				}];
			},
		},
		async created() {
			// this.ruleForm = this.$parent.$parent.ruleForm;
			// 银行
			var causeList = await this.$globals.AxiosPost('bank/finds', {});
			this.causeList = causeList.data;
			// 拆分账户
			var cfzhList = await this.$globals.AxiosPost('dictionaries/selectFind', {
				data_grouping: 'split_account'
			});
			this.cfzhList = cfzhList.data;
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// FfblSz_add.vue?cfb78f86